import React, { useEffect, useState } from 'react';
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryLine } from 'victory';
import { barChartData } from '../../../../@types';
import EmptyStateChart from './Empty';
interface BarChartProps {
  value: string;
  title: string;
  icon?: React.ReactNode;
  standalone: boolean;
  orientation: string;
  colorScale: { invoice: string; expense: string };
  offset: number;
  data: barChartData | any;
  datas: barChartData | any;
  isEmpty?: boolean;
}


const BarChart: React.FC<BarChartProps> = ({
  value,
  title,
  icon,
  data,
  datas,
  standalone,
  orientation,
  colorScale,
  offset,
  isEmpty,
}) => {
  const [expenses, setExpenses] = useState<{ x: string; y: string }[]>([]);
  const [invoices, setInvoices] = useState<{ x: string; y: string }[]>([]);
  const [fills, setFills] = useState<string[]>([]);
  const [TickFormat, setTickFormat] = useState<string[]>([]);
  const [xValues, setXValues] = useState<string[]>([]);
  const [visibleRange, setVisibleRange] = useState({ start: 0, end: 7 });
  const tickLabelStyle = {
    fontSize: 20,
    marginLeft: 50,
    textTransform: 'capitalize',
    fontWeight: 300,
  };

 
  useEffect(() => {
    const newTickFormats: string[] = [];
    const newExpenses: { x: string; y: string }[] = [];
    const newInvoices: { x: string; y: string }[] = [];
    const newXValues: string[] = [];
  
    for (let key in data) {
      newTickFormats.push(key);
      newExpenses.push({ x: key, y: data[key].expense });
      newInvoices.push({ x: key, y: data[key].invoice });
      newXValues.push(key);
    }
  
    setTickFormat(newTickFormats);
    setExpenses(newExpenses);
    setInvoices(newInvoices);
    setXValues(newXValues);
  
    const newFills = [colorScale.invoice, colorScale.expense];
    setFills(newFills);
  }, [data]);
  

  const iconStyle = {
    color: '#0D8DBF',
  };

  const getVisibleData = (fullData: string | any[]) => {
    return fullData.slice(visibleRange.start, visibleRange.end);
  };

  const calculateChartHeight = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1280) {
      return 500;
    } else if (screenWidth >= 768) {
      return 700; 
    } else {
      return 700; 
    }
  }
  const isDataEmpty = Object.values(data).every((item) => item === 0);

  console.log('isEmpty:', isDataEmpty );

  return (
    <div>
      <div className=" xl:mt-[10px] mb-[30px]">
        <div className="xl:pl-[78px] xl:pr-[78px] xl:pt-[54px] lg:pl-[78px] lg:pr-[78px] lg:pt-[54px]">
          <div className="flex justify-between items-center">
            <p className=" text-[15px] md:text-[18px] font-semibold xl:text-[20px] mt-[1em]  px-[1em] ">{title}</p>
            <p className="text-[11px] xl:text-[14px] text-[black] font-semibold flex items-center gap-[8px] px-[1em]">
              {value}
              <span className="icon" style={iconStyle}>
                {icon}
              </span>
            </p>
          </div> 

          <div className="  mt-[10px] px-[1em] ">
          {isEmpty || isDataEmpty ? (
           <EmptyStateChart  />
            ) : (
            <VictoryChart width={1350} height={calculateChartHeight()} domainPadding={{ x: 50 }} >
              <VictoryAxis
                tickValues={TickFormat}
                tickFormat={TickFormat}
                domain={[0, 7]}
                style={{ tickLabels: tickLabelStyle }}
              />
        

<VictoryAxis
  standalone={standalone}
  orientation={orientation}
  dependentAxis
  tickFormat={(tick, index) => {
    if (tick >= 1000000) {
      return `${tick / 1000000}M`;
    } else {
      return `${tick / 1000}K`;
    }
  }}
  domain={[100000, 510000]}
  style={{ tickLabels: { fontSize: 16, y: 340, fontWeight: 300, marginTop: 150 } }}
/>

  
              <VictoryGroup offset={offset} colorScale={fills}>
                <VictoryBar style={{ data: { fill: fills[0], width: 9 } }} data={invoices} />
                <VictoryBar style={{ data: { fill: fills[1], width: 9 } }} data={expenses} />

                
              </VictoryGroup> 
            </VictoryChart>
             )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { BarChart };


